/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { Divider, Flex, HStack, Switch, Text, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { FaArrowLeft, FaArrowRight, FaEnvelope } from 'react-icons/fa'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../../components/ElementoTooltipCmp'
import { InputCmp } from '../../../../components/InputCmp'
import { WhiteContainer } from '../../../../components/WhiteContainer'
import { appApi } from '../../../../services/appApi'
import { ValidaCPF, ValidarEmail } from '../../../../Utils/Helper'
import { Body } from '../../../Layouts/Body'
import { CardColaboradorSi } from '../../components/TabelaAderencia/components/cardColabSI'
import { numberFormatter } from '../../Dashboard'
import * as pdfjsReact from 'pdfjs-dist'
import 'pdfjs-dist/build/pdf.worker.entry'
import { pdfjs } from 'react-pdf'
import { BoxArquivo } from '../components/BoxArquivo/BoxArquivo'
import { useNavigate } from 'react-router-dom'
import LoadingContainer from '../../../../components/LoadingContainer'
import { SwitchCmp } from '../../../../components/SwitchCmp'
import { SelectCmp } from '../../../../components/SelectCmp'

interface IListaPerfilDTO{
  totalRegistrosEncontrados: number
  totalPaginas: number
  resultadoBusca: IperfilDto2[]
}

export interface IperfilDto2 {
  assessmentId: string
  assessmentUserId: string
  email: string
  nome: string
  dataConclusao: string
  pi: number
  self: iSelf
  selo: iSelo
}

interface iSelf {
  aSigma: number
  bSigma: number
  cSigma: number
  dSigma: number
  eSigma: number
  mScore: number
}

interface iSelo {
  definicao: string
  nome: string
  urlAvatar: string
}

// interface IFormData{

//   nome: string
//   email: string
//   cpf: string
//   linkedin?: string
//   cargo?: File
//   curriculo?: File

// }
interface IAnalise {
  nome: string
  email: string
  pi: string
  cpf: string
  pdfCurriculo?: string
  linkedin?: string
  assessmentId: string
  descritivoCargo?: string
  nomeGestor: string
  emailGestor: string
  assessmentIdGestor: string
  quadroDesenvolvimento: string
  guiaRelacionamentoGestor: string
  imageSelf?: string
  nomeCargo: string
  imageSelfGestor: string
  nomeBP: string
  emailBP: string
  performance?: string
  nomeSolicitante: string
  emailSolicitante: string
  tipoCandidato: number
  nineBox?: string
}

interface iModel {
  nome: string
  cpf: string
  email: string
}

interface iModelSolicitante {
  nomeSolicitante: string
  emailSolicitante: string
}

export const SendSI: React.FC = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
  const toast = useToast()
  const nav = useNavigate()
  const [TipoCandidato, setTipoCandidato] = useState(0)
  const [ModelColaborador, setModelColaborador] = useState<iModel>({ cpf: '', email: '', nome: '' })
  const [ModelGestor, setModelGestor] = useState<iModel>({ cpf: '', email: '', nome: '' })
  const [BP, setBP] = useState<iModel>({ cpf: '', email: '', nome: '' })
  const [PerfilGestor, setPerfilGestor] = useState<IperfilDto2>()
  const [Perfil, setPerfil] = useState<IperfilDto2>()
  const [pagColaborador, setPagColaborador] = useState(0)
  const [pagGestor, setPagGestor] = useState(0)
  const [IsLoading, setIsLoading] = useState(false)
  const [IsLoadingLista, setIsLoadingLista] = useState(false)
  const [IsInvalid, setIsInvalid] = useState(false)
  const [ImageSelf, setImageSelf] = useState<string>()
  const [ImageSelfGestor, setImageSelfGestor] = useState<string>()
  const [BuscarEmail, setBuscarEmail] = useState(false)
  const [BuscarEmailGestor, setBuscarEmailGestor] = useState(false)

  // const { register, handleSubmit } = useForm<IFormData>()
  const [NineBox, setNineBox] = useState('')
  const [descricaoCargo, setDescricaoCargo] = useState('')
  const [NomeCargo, setNomeCargo] = useState('')
  const [curriculo, setCurriculo] = useState('')
  const [quadroDesenvolvimento, setQuadroDesenvolvimento] = useState('')
  const [guiaRelacionamento, setGuiaRelacionamento] = useState('')
  const [urlCurriculo, setUrlCurriculo] = useState('')
  const [Model, setModel] = useState<iModelSolicitante>({ nomeSolicitante: '', emailSolicitante: '' })
  const [PI, setPI] = useState('')
  const [RelatorioPerformance, setRelatorioPerformance] = useState('')

  const [PerfisColaborador, setPerfisColaborador] = useState<IListaPerfilDTO>({
    resultadoBusca: [],
    totalPaginas: 0,
    totalRegistrosEncontrados: 0
  })
  const [PerfisGestor, setPerfisGestor] = useState<IListaPerfilDTO>({
    resultadoBusca: [],
    totalPaginas: 0,
    totalRegistrosEncontrados: 0
  })

  function OnPrevPage(isColab: boolean): void {
    const perfis = isColab ? PerfisColaborador : PerfisGestor
    const pag = isColab ? pagColaborador : pagGestor
    if (pag !== 0) {
      isColab ? setPagColaborador(pag - 1) : setPagGestor(pag - 1)
    } else {
      isColab ? setPagColaborador(Math.ceil(perfis.totalRegistrosEncontrados / 28) - 1) : setPagGestor(Math.ceil(perfis.totalRegistrosEncontrados / 28) - 1)
    }
  }

  function OnNextPage(isColab: boolean): void {
    const perfis = isColab ? PerfisColaborador : PerfisGestor
    const pag = isColab ? pagColaborador : pagGestor
    if (pag < Math.ceil(perfis.totalRegistrosEncontrados / 28) - 1) {
      isColab ? setPagColaborador(pag + 1) : setPagGestor(pag + 1)
    } else {
      isColab ? setPagColaborador(0) : setPagGestor(0)
    }
  }

  const onSubmit = (): void => {
    setIsInvalid(false)

    if ((!ImageSelfGestor || ImageSelfGestor === undefined || ImageSelfGestor === '') && !PerfilGestor) {
      toast({
        title: 'Selecione o arquivo de perfil PI do gestor',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }
    if (descricaoCargo === '') {
      setIsInvalid(true)
      toast({
        title: 'Selecione o arquivo de descrição da vaga',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (NomeCargo === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o nome do cargo/vaga',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (curriculo === '' && urlCurriculo === '') {
      setIsInvalid(true)
      toast({
        title: 'Selecione o arquivo de currículo ou preencha com a url do linkedin',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (PI === '' && !Perfil) {
      setIsInvalid(true)
      toast({
        title: 'Selecione o arquivo de perfil PI',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (quadroDesenvolvimento === '' && !Perfil) {
      setIsInvalid(true)
      toast({
        title: 'Selecione o arquivo do quadro de desenvolvimento',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!ModelColaborador.nome || ModelColaborador.nome === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o nome do colaborador',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (ModelColaborador.nome.split(' ').length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Preencha nome e sobrenome do colaborador',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!ModelColaborador.email || ModelColaborador.email === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o email do colaborador',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!BP.nome || BP.nome === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o nome do business partner',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!Model.nomeSolicitante || Model.nomeSolicitante === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o nome do solicitante',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (BP.nome.split(' ').length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Preencha nome e sobrenome do business partner',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!BP.email || BP.email === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o email do business partner',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!Model.emailSolicitante || Model.emailSolicitante === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o email do solicitante',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (ModelColaborador.cpf.length > 0 && !ValidaCPF(ModelColaborador.cpf)) {
      setIsInvalid(true)
      toast({
        title: 'Preencha corretamente o CPF do colaborador',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!ModelGestor.nome || ModelGestor.nome === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o nome do Gestor',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (ModelGestor.nome.split(' ').length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Preencha nome e sobrenome do gestor',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!ModelGestor.email || ModelGestor.email === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o email do Gestor',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!ImageSelf && !Perfil) {
      setIsInvalid(true)
      toast({
        title: 'Preencha o arquivo de Perfil PI',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    const payload: IAnalise = {
      nome: ModelColaborador.nome,
      email: ModelColaborador.email,
      cpf: ModelColaborador.cpf,
      descritivoCargo: descricaoCargo,
      pdfCurriculo: curriculo,
      assessmentId: Perfil?.assessmentId ?? '',
      assessmentIdGestor: PerfilGestor?.assessmentId ?? '',
      nomeGestor: ModelGestor.nome,
      emailGestor: ModelGestor.email,
      linkedin: urlCurriculo,
      pi: PI,
      guiaRelacionamentoGestor: guiaRelacionamento ?? '',
      quadroDesenvolvimento,
      imageSelf: ImageSelf,
      nomeCargo: NomeCargo,
      imageSelfGestor: ImageSelfGestor ?? '',
      nomeBP: BP.nome,
      emailBP: BP.email,
      performance: RelatorioPerformance,
      nomeSolicitante: Model.nomeSolicitante,
      emailSolicitante: Model.emailSolicitante,
      tipoCandidato: TipoCandidato,
      nineBox: NineBox !== '' ? NineBox : undefined
    }

    setIsLoading(true)
    try {
      appApi.post('api/SI/CadastrarAnalise', payload).then(r => nav('/PRISMAH/Dashboard')).catch(err => console.log(err)).finally(() => setIsLoading(false))
      // appApi.post('api/SI/Analisar', payload).then(r => console.log(r)).catch(err => console.log(err))
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  function GetIsInvalid(val: string): boolean {
    return val === '' && IsInvalid
  }

  useEffect(() => {
    buscar(true)
  }
  , [pagColaborador])

  useEffect(() => {
    buscar(false)
  }
  , [pagGestor])

  function buscar(isColaborador: boolean): void {
    const buscaPorEmail = BuscarEmail || BuscarEmailGestor
    const nome = isColaborador ? ModelColaborador.nome : ModelGestor.nome
    const email = isColaborador ? ModelColaborador.email : ModelGestor.email
    if (nome === '') return
    if (buscaPorEmail && email === '') return
    setIsLoadingLista(true)
    appApi.get(`api/SI/BuscaPI?nome=${buscaPorEmail ? email : nome}&tamanho=${28}&pagina=${isColaborador ? pagColaborador : pagGestor}&exibirDefinicaoSelo=true`).then(res => {
      if (res.status === 200) {
        const data: IListaPerfilDTO = res.data
        isColaborador ? setPerfisColaborador(data) : setPerfisGestor(data)
        setIsLoadingLista(false)
      }
    }).catch(err => console.log(err))
  }

  const handleFileCargoChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.includes('.docx') && !file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".docx" ou ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setDescricaoCargo(reader.result as string)
      }
    }
  }
  const handleFileCurriculoChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setCurriculo(reader.result as string)
      }
    }
  }
  const handleFilePiChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setPI(reader.result as string)
      }
    }
  }

  const handleFilePerformanceChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.includes('.docx') && !file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".docx" ou ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setRelatorioPerformance(reader.result as string)
      }
    }
  }

  const handleFilePiGestorChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        convertPDFToImages(reader.result as string, true)
      }
    }
  }
  const handleFilePiQuadro = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setQuadroDesenvolvimento(reader.result as string)
      }
    }
  }
  const handleFilePiRelacionamento = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setGuiaRelacionamento(reader.result as string)
      }
    }
  }

  function GetPerfis(): any {
    return <>
      <Flex gap={'.325rem'}>
        Colaborador:
        <strong>{Perfil?.nome ?? 'Escolha pendente*'}</strong>
      </Flex>
      <Flex gap={'.325rem'}>
        Gestor:
        <strong>{PerfilGestor?.nome ?? 'Escolha pendente*'}</strong>
      </Flex>
    </>
  }

  const convertPDFToImages = async (PDF: string, isGestor: boolean) => {
    try {
      const pdf = await pdfjsReact.getDocument(PDF).promise

      const page = await pdf.getPage(1)
      const scale = 2
      const viewport = page.getViewport({ scale })

      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')

      if (!context) return

      canvas.width = viewport.width
      canvas.height = viewport.height

      await page.render({ canvasContext: context, viewport }).promise

      // Criar um novo canvas para recorte
      const croppedCanvas = document.createElement('canvas')
      const croppedContext = croppedCanvas.getContext('2d')

      if (!croppedContext) return

      const cropHeight = viewport.height * 0.18
      const cropWidth = viewport.width * 0.9
      const startX = (viewport.width - cropWidth) / 2
      const startY = viewport.height * 0.245

      croppedCanvas.width = cropWidth
      croppedCanvas.height = cropHeight

      croppedContext.drawImage(
        canvas,
        startX, startY, cropWidth, cropHeight,
        0, 0, cropWidth, cropHeight
      )

      if (isGestor) {
        setImageSelfGestor(croppedCanvas.toDataURL('image/png'))
      } else {
        setImageSelf(croppedCanvas.toDataURL('image/png'))
      }
    } catch (error) {
      console.error('Erro ao converter PDF:', error)
    }
  }

  useEffect(() => {
    if (PI) {
      convertPDFToImages(PI, false)
    }
  }, [PI])

  return (
    <LoadingContainer linhas={42} loading={IsLoading} px='3rem' my='3rem'>
      <Body isLoading={IsLoading}>
        <WhiteContainer margin='.5rem 0 1rem 0'>
          <Flex direction='column' minHeight={'400px'} gap={'1.25rem'}>
            <Flex flexDir={'column'}>
              <h2>Relatório PRISMAH</h2>
              <Text fontSize={'14px'} fontWeight={400} color={'var(--Gray2)'}>Selecione o candidato e o gestor da vaga</Text>
            </Flex>

            <InputCmp
              label='Nome do candidato'
              errorBorderColor='red.300'
              isInvalid={GetIsInvalid(ModelColaborador.nome)}
              OnChange={(s) => setModelColaborador({ ...ModelColaborador, nome: s })} placeholder='Digite o nome do candidato' />

            <InputCmp
              label='Email do candidato'
              isInvalid={GetIsInvalid(ModelColaborador.email) || (ModelColaborador.email.length > 0 && !ValidarEmail(ModelColaborador.email))}
              errorBorderColor='red.300'
              OnChange={(s) => setModelColaborador({ ...ModelColaborador, email: s })} value={ModelColaborador.email} placeholder='Digite o email do candidato' />

            <SwitchCmp OnChange={(val) => val ? setTipoCandidato(1) : setTipoCandidato(0) } legendaEsquerda='Candidato Interno' legendaDireita='Candidato Externo' value={TipoCandidato === 1}/>

            <Flex justifyContent={'center'} alignItems={'center'} my={'.75rem'} gap={'1rem'}>
           <Text fontSize={'sm'} fontWeight={'bold'}>Buscar por Email</Text>
            <Switch checked={BuscarEmail} onChange={(s) => setBuscarEmail(s.target.checked)}>
          </Switch>
              <ElementoTooltipCmp label={ModelColaborador.nome === '' ? 'Preencha o nome do candidato para pesquisar os perfis PI' : ''} bg={'var(--Red)'}>
                <ButtonCmp leftIcon={<FaEnvelope/>} w='16rem' isDisabled={ModelColaborador.nome === ''} onClick={() => { pagColaborador !== 0 ? setPagColaborador(0) : buscar(true) }} VarColor='Azul'>
                    Procurar PI do candidato
                </ButtonCmp>
              </ElementoTooltipCmp>
              <ElementoTooltipCmp label={!Perfil ? 'Ainda não foi selecionado nenhum perfil PI do candidato' : ''} bg={'var(--Red)'}>
                <ButtonCmp VarColor='Rosa' isDisabled={!Perfil} onClick={() => setPerfil(undefined)}>Limpar seleção de PI do colaborador</ButtonCmp>
              </ElementoTooltipCmp>
            </Flex>

            <LoadingContainer linhas={10} loading={IsLoadingLista}>
              {!Perfil && PerfisColaborador.resultadoBusca.length > 0 && <Flex direction={'column'} gap={'.75rem'} maxH={'22.5rem'} overflowY={'auto'} boxShadow={'var(--SombraBackground)'} border={'1px solid var(--c5)'} p={'1rem .5rem'}>
                {PerfisColaborador.resultadoBusca.map((j, i) =>
                  <Flex>
                    <CardColaboradorSi
                      perfil={j}
                      selecionado={false}
                      onSelect={() => {
                        setPerfil(j)
                      }}
                      key={j.assessmentUserId}
                      par={i % 2 !== 0}
                    />
                  </Flex>
                )}
              </Flex>}
            </LoadingContainer>
            {!Perfil && PerfisColaborador.totalRegistrosEncontrados > 0 && <Flex justifyContent={'end'}>
              <HStack mt={0} mx={'1.25rem'} p={'.25rem'} fontSize={'.875rem'}>
                <Text>Página:</Text>
                <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => OnPrevPage(true)} VarColor='Green2'><FaArrowLeft/></ButtonCmp>
                <Text>{numberFormatter.format(pagColaborador + 1)} / {Math.ceil(PerfisColaborador.totalRegistrosEncontrados / 28)}</Text>
                <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => OnNextPage(true)} VarColor='Green2'><FaArrowRight/></ButtonCmp>
              </HStack>
            </Flex>}
            {Perfil && <CardColaboradorSi
              perfil={Perfil}
              selecionado={true}
              onSelect={() => {
                setPerfil(Perfil)
              }}
              key={Perfil.assessmentUserId}
              par
              />}
            <Divider opacity={'.8'} borderColor={'var(--Azul)'} my={'.75rem'}/>

            <InputCmp
              label='CPF do candidato'
              isInvalid={IsInvalid && (ModelColaborador.cpf.length > 0 && (ModelColaborador.cpf.length < 11 || !ValidaCPF(ModelColaborador.cpf)))}
              errorBorderColor='red.300'
              OnChange={(s) => setModelColaborador({ ...ModelColaborador, cpf: s })} value={ModelColaborador.cpf} placeholder='Digite o CPF do candidato' />

            <SelectCmp title='9Box do candidato' value={NineBox} OnChange={setNineBox}>
              <option value={''}>Selecione o 9box do candidato</option>
              <option value={'Aposta'}>Aposta</option>
              <option value={'Atenção'}>Atenção</option>
              <option value={'Crítico'}>Crítico</option>
              <option value={'Destaque'}>Destaque</option>
              <option value={'Eficaz'}>Eficaz</option>
              <option value={'Eficiente'}>Eficiente</option>
              <option value={'Importante'}>Importante</option>
              <option value={'Observação'}>Observação</option>
              <option value={'Talento'}>Talento</option>
            </SelectCmp>

            <InputCmp
              label='Nome da vaga'
              errorBorderColor='red.300'
              OnChange={(s) => { setNomeCargo(s) }} value={NomeCargo} placeholder='Digite o nome da vaga' />

            <InputCmp
              label='LinkedIn do candidato'
              errorBorderColor='red.300'
              OnChange={(s) => { setUrlCurriculo(s) }} value={urlCurriculo} placeholder='Digite a url do linkedIn' />

            <Divider opacity={'.9'} borderColor={'var(--c6)'} mt={'.75rem'}/>

            <InputCmp
              label='Nome do BP (business partner)'
              errorBorderColor='red.300'
              isInvalid={GetIsInvalid(BP.nome)}
              OnChange={(s) => setBP({ ...BP, nome: s })} placeholder='Digite o nome do business partner' />

            <InputCmp
              label='Email do BP (business partner)'
              isInvalid={GetIsInvalid(BP.email) || (BP.email.length > 0 && !ValidarEmail(BP.email))}
              errorBorderColor='red.300'
              OnChange={(s) => setBP({ ...BP, email: s })} value={BP.email} placeholder='Digite o email do business partner' />

            <InputCmp
              label='Nome do solicitante'
              isInvalid={GetIsInvalid(Model.nomeSolicitante)}
              errorBorderColor='red.300'
              OnChange={(s) => setModel({ ...Model, nomeSolicitante: s })} value={Model.nomeSolicitante} placeholder='Digite o nome do solicitante' />

              <InputCmp
                label='Email do solicitante'
                isInvalid={GetIsInvalid(Model.emailSolicitante) || (Model.emailSolicitante.length > 0 && !ValidarEmail(Model.emailSolicitante))}
                errorBorderColor='red.300'
                OnChange={(s) => setModel({ ...Model, emailSolicitante: s })} value={Model.emailSolicitante} placeholder='Digite o email do solicitante' />

            <Divider opacity={'.9'} borderColor={'var(--c6)'} mt={'.75rem'}/>

            <Flex flexDir={'column'} gap={'1.75rem'}>
              <Text fontWeight={700} fontSize={'18px'}>Arquivos obrigatórios</Text>
              <Flex alignItems={'center'} justifyContent={'center'} flexWrap={'wrap'} gap={'3rem'}>
                <BoxArquivo
                  title='Currículo'
                  isOpcional={false}
                  AtualizarArquivo={handleFileCurriculoChange}
                  id={'fileCurriculo'}
                  tipo={1}
                />
                <BoxArquivo
                  isOpcional={false}
                  title='Descrição da vaga'
                  AtualizarArquivo={handleFileCargoChange}
                  id={'fileCargo'}
                  tipo={2}
                />
            </Flex>

            </Flex>

            <InputCmp
              label='Nome do gestor'
              errorBorderColor='red.300'
              isInvalid={GetIsInvalid(ModelGestor.nome)}
              OnChange={(s) => setModelGestor({ ...ModelGestor, nome: s })} placeholder='Digite o nome do gestor' />

            <InputCmp
              label='Email do gestor'
              isInvalid={GetIsInvalid(ModelGestor.email) || (ModelGestor.email.length > 0 && !ValidarEmail(ModelGestor.email))}
              errorBorderColor='red.300'
              OnChange={(s) => setModelGestor({ ...ModelGestor, email: s })} value={ModelGestor.email} placeholder='Digite o email do gestor' />

            <Flex justifyContent={'center'} alignContent={'center'} my={'.75rem'} gap={'1rem'}>

              <Text fontSize={'sm'} fontWeight={'bold'}>Buscar por Email</Text>
            <Switch checked={BuscarEmailGestor} onChange={(s) => setBuscarEmailGestor(s.target.checked)}>
           </Switch>
              <ElementoTooltipCmp label={ModelGestor.nome === '' ? 'Preencha o nome do gestor para pesquisar os perfis PI' : ''} bg={'var(--Red)'}>
                <ButtonCmp leftIcon={<FaEnvelope/>} isDisabled={ModelGestor.nome === ''} w='16rem' onClick={() => { pagGestor !== 0 ? setPagGestor(0) : buscar(false) }} VarColor='Azul'>
                    Procurar PI do gestor
                </ButtonCmp>
              </ElementoTooltipCmp>
              <ElementoTooltipCmp label={!PerfilGestor ? 'Ainda não foi selecionado nenhum perfil PI do gestor' : ''} bg={'var(--Red)'}>
                <ButtonCmp VarColor='Rosa' isDisabled={!PerfilGestor} onClick={() => setPerfilGestor(undefined)}>Limpar seleção de PI do gestor</ButtonCmp>
              </ElementoTooltipCmp>
            </Flex>
            <LoadingContainer linhas={10} loading={IsLoadingLista}>
              {!PerfilGestor && PerfisGestor.resultadoBusca.length > 0 && <Flex direction={'column'} gap={'.75rem'} maxH={'22.5rem'} overflowY={'auto'} boxShadow={'var(--SombraBackground)'} border={'1px solid var(--c5)'} p={'1rem .5rem'}>
                {PerfisGestor.resultadoBusca.map((j, i) =>
                  <Flex>
                    <CardColaboradorSi
                      perfil={j}
                      selecionado={false}
                      onSelect={() => {
                        setPerfilGestor(j)
                      }}
                      key={j.assessmentUserId}
                      par={i % 2 !== 0}
                    />
                  </Flex>
                )}
              </Flex>}
            </LoadingContainer>
            {!PerfilGestor && PerfisGestor.totalRegistrosEncontrados > 0 && <Flex justifyContent={'end'}>
              <HStack mt={0} mx={'1.25rem'} p={'.25rem'} fontSize={'.875rem'}>
                <Text>Página:</Text>
                <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => OnPrevPage(false)} VarColor='Green2'><FaArrowLeft/></ButtonCmp>
                <Text>{numberFormatter.format(pagGestor + 1)} / {Math.ceil(PerfisGestor.totalRegistrosEncontrados / 28)}</Text>
                <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => OnNextPage(false)} VarColor='Green2'><FaArrowRight/></ButtonCmp>
              </HStack>
            </Flex>}
            {PerfilGestor && <CardColaboradorSi
              perfil={PerfilGestor}
              selecionado={true}
              onSelect={() => {
                setPerfilGestor(PerfilGestor)
              }}
              key={PerfilGestor.assessmentUserId}
              par
              />}
          </Flex>

          {/* <Flex flexDir={'column'} gap={'1.75rem'} mt={'1rem'}>
            <Text fontWeight={700} fontSize={'18px'}>Arquivos caso não selecione PI do gestor e do colaborador</Text>
            <Flex alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'}>
              <BoxArquivo
                title='PI'
                isOpcional={true}
                AtualizarArquivo={handleFilePiChange}
                id={'filePI'}
                tipo={1}
              />
              <BoxArquivo
                isOpcional={true}
                title='PI - Quadro de desenvolvimento'
                AtualizarArquivo={handleFilePiQuadro}
                id={'filePIQuadro'}
                tipo={1}
              />
              <BoxArquivo
                isOpcional={true}
                title='PI do Gestor'
                AtualizarArquivo={handleFilePiGestorChange}
                id={'filePIGestor'}
                tipo={1}
              />
            </Flex>
          </Flex> */}
          <Flex flexDir={'column'} gap={'1.75rem'} mt={'1rem'}>
            <Text fontWeight={700} fontSize={'18px'}>Arquivos opcionais</Text>
            <Flex alignItems={'center'} justifyContent={'start'} flexWrap={'wrap'} gap={'3rem'}>
              <BoxArquivo
                title='Relatório de performance'
                isOpcional={true}
                AtualizarArquivo={handleFilePerformanceChange}
                id={'filePerformance'}
                tipo={1}
              />
              {/* <BoxArquivo
                  isOpcional={true}
                  title='PI - Guia de relacionamento'
                  AtualizarArquivo={handleFilePiRelacionamento}
                  id={'filePIRelacionamento'}
                  tipo={1}
                /> */}
            </Flex>
          </Flex>
        </WhiteContainer>
        <Flex justifyContent={'end'} pb={(Perfil ?? PerfilGestor) ? '3rem' : ''}>
          <ButtonCmp leftIcon={<FaEnvelope/>} onClick={onSubmit} VarColor='Rosa' size='xs' w='16rem'>
            Processar relatório PRISMAH
          </ButtonCmp>
        </Flex>
      </Body>
      {(Perfil ?? PerfilGestor) && <Flex borderTop={'1px solid var(--c6)'} bg={'white'} pos={'fixed'} bottom={'0'} w={'100%'} py={'1rem'}justifyContent={'center'} gap={'3rem'}>
        {GetPerfis()}
      </Flex>}
    </LoadingContainer>
  )
}
